import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export type AvatarVariant = 'icon' | 'text' | 'image';
export type AvatarSize = 'large' | 'medium' | 'small';

export const AvatarContainer = styled.div<{ size: AvatarSize; dark?: boolean }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: solid 1px
    ${(props) =>
      props.dark
        ? props.theme.atlas.semantic.color.type.default
        : props.theme.atlas.semantic.color.action.primary.default};
  border-radius: 100%;

  ${(props) => {
    switch (props.size) {
      case 'large':
        return 'width: 64px; height: 64px;';
      case 'medium':
        return 'width: 40px; height: 40px;';
      case 'small':
        return 'width: 32px; height: 32px;';
    }
  }}

  &:hover {
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  }
`;

export const AvatarText = styled.span<{ size: AvatarSize; color: string }>`
  ${(props) => `color: ${props.color};`}
  ${(props) => {
    switch (props.size) {
      case 'large':
        return textStyleCss(props.theme.atlas.typography.semantic.body);
      case 'medium':
        return textStyleCss(props.theme.atlas.typography.semantic.bodySmall);
      case 'small':
        return textStyleCss(props.theme.atlas.typography.semantic.caption);
    }
  }}
`;

export const AvatarImage = styled.img<{ size: AvatarSize }>`
  width: 100%;
  height: 100%;
  border-radius: 100%;
`;
